import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  width: 100%;
`;

export const DefaultOfferData: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  color: ${Color.Gray500};
  line-height: 22px;

  & + & {
    margin-left: 5px;
  }
`;

export const Price: StyledComponent<typeof DefaultOfferData> = styled(DefaultOfferData)`
  font-weight: ${FontWeight.Medium};
  color: ${Color.Black};
`;

export const Name: StyledComponent<typeof DefaultOfferData> = styled(DefaultOfferData)`
  font-weight: ${FontWeight.Medium};
  color: ${Color.Black};
`;

export const Email: StyledComponent<typeof DefaultOfferData> = styled(DefaultOfferData)`
  color: ${Color.Black};
`;
